import deviceConfigReducer from "./reducers";

export default deviceConfigReducer;